import React from "react";
import { FaFacebook, FaDiscord } from "react-icons/fa";
import {
  FiGithub,
  FiTwitter,
  FiLinkedin,
} from "react-icons/fi";

const Footer = () => {
  const socialLinks = [
    {
      id: 1,
      icon: <FaDiscord />,
      url: "https://discordapp.com/users/1071063701622366218",
    },
    {
      id: 2,
      icon: <FiGithub />,
      url: "https://github.com/its-shojib",
    },
    {
      id: 3,
      icon: <FiTwitter />,
      url: "https://x.com/its_shojib",
    },
    {
      id: 4,
      icon: <FiLinkedin />,
      url: "https://linkedin.com/in/md-shojib-hossain",
    },
    {
      id: 5,
      icon: <FaFacebook />,
      url: "https://www.facebook.com/mdshojib.hossain.7927",
    },
  ];

  return (
    <div className="container mx-auto">
      <div className="pt-20 sm:pt-30 pb-8 mt-20 border-t-2 border-primary-light dark:border-secondary-dark">
        {/* Footer social links */}
        <div className="font-general-regular flex flex-col justify-center items-center">
          <p className="text-3xl sm:text-4xl text-primary-dark dark:text-primary-light mb-5 uppercase">
            Follow me on
          </p>
          <ul className="flex gap-1 lg:gap-5 sm:gap-8">
            {socialLinks.map((link) => (
              <a
                href={link.url}
                data-aos="zoom-in"
                target="__blank"
                key={link.id}
                className="text-gray-400 hover:text-indigo-500 dark:hover:text-indigo-400 cursor-pointer rounded-lg bg-gray-50 dark:bg-ternary-dark hover:bg-gray-100 shadow-sm p-4 duration-300"
              >
                <i className="text-xl sm:text-2xl md:text-3xl">{link.icon}</i>
              </a>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Footer;
